import { IncidentModel } from './incident.model';

export class IncidentUnderageAffidavitModel extends IncidentModel {
    public incidentUnderageAffidavitId = 0;
    public citingAgencyTypeId = 0;
    public bac = 0.0;
    public orderOfSuspensionServedByOfficerDate: any;
}
